import React from 'react';
import { Toaster } from 'sonner';
import { useMediaQuery } from 'react-responsive';

/**
 * ToasterConfig - A responsive toast notification configuration component
 *
 * @component
 * @description
 * This presentation component configures and displays toast notifications using the Sonner Toaster
 * component with responsive behavior based on the user's device screen size.
 *
 * Key features:
 * - Automatically adjusts position based on screen size (top-right on desktop, bottom-left on mobile)
 * - Shows close button only on mobile devices where manual dismissal is more common
 * - Applies consistent styling through the "toaster-card" class
 *
 * @returns {JSX.Element} A configured Toaster component
 */
const ToasterConfig: React.FC = () => {
  const isDesktop = useMediaQuery({ minWidth: 768 });

  return (
    <Toaster
      className="toaster-card"
      position={isDesktop ? "top-right" : "bottom-left"}
      closeButton={!isDesktop}
    />
  );
};

export default ToasterConfig;